import { Heading, Icon, IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Button } from 'native-base';
import React, { useCallback } from 'react';

export namespace RateManagementHeaderSectionTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const HeaderSection: React.FC<RateManagementHeaderSectionTypes.Props> = ({ isMobile }) => {
  const navigation = useNavigation();

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  return (
    <>
      <HStack
        paddingBottom={Spacing['inset.xxxs']}
        justifyContent={'space-between'}
        alignItems={'center'}
        space={Spacing['inline.xxxs']}>
        <HStack justifyContent={'center'} alignItems={'center'} space={Spacing['inset.nano']}>
          {isMobile ? (
            <HStack marginTop={Spacing['inset.xs']} marginBottom={Spacing['inline.xxs']}>
              <Button
                p={0}
                testID="return-button"
                size={'lg'}
                variant="textLink"
                leftIcon={
                  <Icon
                    testId="return-button-icon"
                    name={'ArrowLeft'}
                    size="xxs"
                    color={Color['neutral.black']}
                  />
                }
                justifyContent="start"
                onPress={goBack}
              />
              <Text
                textAlign={'center'}
                color="brand.primary.principal"
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.lg']}
                variant="semibold">
                Clientes restritos
              </Text>
            </HStack>
          ) : (
            <>
              <IconButton
                icon="ArrowLeft"
                testId="return-button"
                iconColor={Color['brand.tertiary.principal']}
                iconSize="xs"
                shadow={3}
                variant={'link'}
                onPress={goBack}
              />
              <VStack padding={Spacing['inset.nano']}>
                <Heading paddingBottom={Spacing['inset.quarck']} testId="qa" size="h2">
                  Clientes restritos
                </Heading>
                <Text
                  fontSize={Typography['fontsize.md']}
                  fontWeight={Typography['fontweight.light']}>
                  Solicite o desbloqueio de clientes que optaram por não receber ordens via
                  WhatsApp.
                </Text>
              </VStack>
            </>
          )}
        </HStack>
      </HStack>
    </>
  );
};
